import ListCard2 from './ListCard2';

export default ListCard2;
